<template>
  <div class="default-layout">
    <el-container>
      <!-- 页头 -->
      <el-header class="page-header header-85">
        <page-header ref="header" :layout="'default'">
          <template slot="title">
            <img src="/img/header/logo.svg"/>
            <div style="width: 1px;height: 30px;border: 1px solid #e1e5f4;margin-left: 8.5px;margin-right: 15.5px"/>
            <div class="logo-text">{{ title }}</div>
          </template>
          <template slot="right-panel">
            <right-navbar/>
          </template>
        </page-header>
      </el-header>
      <page-container ref="pageContainer" :layout="'default'"/>
    </el-container>
    <base-dialog customClass="dialog-custom" ref="modifyPasswordDialog" @determine="modifyPasswordDialogDetermine()"
                 @cancel="modifyPasswordDialogClose()" title="修改密码" :pagination="false">
      <div class="dialog-password-title">
        <i class="el-icon-warning"/>
        密码应为8-16位，必须包含大写字母、小写字母和数字
      </div>
      <el-form class="zwx-form" style="padding: 0 !important;" key="modifyForm" ref="modifyForm"
               :model="modifyForm" :rules="modifyFormRules" label-position="right">
        <div class="edit-form" style="max-width: 392px; padding: 10px 0 5px 20px !important;">
          <el-form-item label-width="82px" label="旧的密码：" prop="oldPassword">
            <el-input class="zwx-input zwx-input-password" style="width: 290px !important;"
                      v-model="modifyForm.oldPassword" placeholder="请输入" :type="oldView ? 'password' : null">
              <i slot="suffix"
                 :class="oldView?'el-input__icon  outline chis-icon-outline-eye':'el-input__icon outline chis-icon-outline-eye-invisible'"
                 @click="passSeeOld()"/>
            </el-input>
          </el-form-item>
          <el-form-item label-width="82px" label="新的密码：" prop="newPassword">
            <el-input class="zwx-input zwx-input-password" style="width: 290px !important;"
                      v-model="modifyForm.newPassword" placeholder="请输入" :type="newView ? 'password' : null">
              <i slot="suffix"
                 :class="newView?'el-input__icon  outline chis-icon-outline-eye':'el-input__icon outline chis-icon-outline-eye-invisible'"
                 @click="passSeeNew()"/>
            </el-input>
          </el-form-item>
          <el-form-item label-width="82px" label="确认密码：" prop="confirmPassword">
            <el-input class="zwx-input zwx-input-password" style="width: 290px !important;"
                      v-model="modifyForm.confirmPassword" placeholder="请输入" :type="confirmView ? 'password' : null">
              <i slot="suffix"
                 :class="confirmView?'el-input__icon  outline chis-icon-outline-eye':'el-input__icon outline chis-icon-outline-eye-invisible'"
                 @click="passSeeConfirm()"/>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
    </base-dialog>
    <!--文件预览弹框-->
    <file-preview ref="filePreview"/>
  </div>
</template>
<script>
import PageHeader from '../../components/navigation/page-header/PageHeader.vue'
import PageContainer from '../PageContainer.vue'

export default {
  name: 'DefaultLayout',
  components: {
    PageHeader,
    PageContainer,
  },
  data() {
    return {
      api: this.$store.state.api,
      title: this.$store.state.title,
      autoLogout: this.$route.meta.autoLogout === undefined ? true : this.$route.meta.autoLogout,
      oldView: true,
      newView: true,
      confirmView: true,
      initMenu: '',
      modifyForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      modifyFormRules: {
        oldPassword: [{required: true, message: '请输入旧的密码', trigger: ['change', 'blur']}],
        newPassword: [{required: true, validator: this.$validate.password, trigger: ['change', 'blur']}],
        confirmPassword: [{required: true, validator: this.confirmPasswordRules, trigger: ['change', 'blur']}],
      },
    }
  },
  created() {
    //监听postmessage
    window.addEventListener('message', this.messageHandler, false)
    window.addEventListener('storage', this.storageHandler, false)
  },
  mounted() {
    this.$zwxCookie.addCookie('nothingDoingTime', Date.now().toString())
  },
  watch: {},
  methods: {
    passSeeOld() {
      this.oldView = !this.oldView
    },
    passSeeNew() {
      this.newView = !this.newView
    },
    passSeeConfirm() {
      this.confirmView = !this.confirmView
    },
    storageHandler() {
      if (!this.$zwxCookie.getCookie("msTokenId")) {
        this.$router.push({name: 'Login'})
      }
    },
    messageHandler(event) {
      const {data} = event
      this[data.handlerType] && this[data.handlerType](data.params)
    },
    menuJump(val) {
      this.$refs.pageContainer.menuJump(val.name)
    },
    confirmPasswordRules(rule, value, callback) {
      if (!rule.required && (value === undefined || value === null || value.length === 0)) return callback()
      if (this.modifyForm.newPassword !== this.modifyForm.confirmPassword) return callback(new Error('两次输入的密码不一致'))
      return callback()
    },
    modifyPassword() {
      this.$refs.modifyPasswordDialog.show(true)
    },
    modifyPasswordDialogDetermine() {
      this.$refs['modifyForm'].validate(valid => {
        if (valid) {
          this.$emit('loading', true)
          let data = {
            oldPassword: this.$zwxSm.sm2Encrypt123(this.modifyForm.oldPassword),
            newPassword: this.$zwxSm.sm2Encrypt123(this.modifyForm.newPassword),
          }
          this.$system.post(this.api + '/systematic/modifyUserInfoPassword-1', data, true, true, data => {
            if (data.type === '00') {
              this.$system.notify('成功', data.mess, 'success')
              this.$refs.modifyPasswordDialog.show(false)
              this.$emit('loading', false)
            } else if (data.type === '99') {
              this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
            } else {
              this.$system.notify('错误', data.mess, 'error')
              this.$emit('loading', false)
            }
          }, () => {
            this.$system.notify('错误', '网络连接失败', 'error')
            this.$emit('loading', false)
          })
        }
      })
    },
    modifyPasswordDialogClose() {
      this.$refs.modifyPasswordDialog.show(false)
      this.modifyForm.oldPassword = ''
      this.modifyForm.newPassword = ''
      this.modifyForm.confirmPassword = ''
    },
    previewFile(data) {
      let previewFileList = []
      if (!this.$CommonTools.verifyIsBlank(data.fileList)) {
        data.fileList.forEach((file) => {
          let item = {
            fileName: file.fileName,
            filePath: file.filePath,
          }
          previewFileList.push(item)
        })
      }
      this.$nextTick(function () {
        this.$refs.filePreview.initPreviewFile(previewFileList, data.index)
      })
    },
  },
  beforeDestroy() {
    // if (this.timer !== null) clearInterval(this.timer)
    window.removeEventListener('message', this.messageHandler, false)
    window.removeEventListener('storage', this.storageHandler, false)
  },
}
</script>
<style lang="less">
.logo-text {
  font-family: "Harmony Medium";
  font-size: 20px;
  line-height: 18px;
  color: #3a485e;
}

.dialog-custom .el-dialog {
  min-width: 0 !important;
  width: 420px !important;
}

.dialog-custom .dialog-password-title {
  font-size: 13px !important;
  color: #475669 !important;
  font-weight: 400 !important;
  margin-left: 20px !important;
  margin-top: 10px !important;
}

.dialog-custom .el-icon-warning {
  color: #4494f9 !important;
}
</style>